import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import { submitFallbackDetails, updateFallbackDetails } from "../../../../../api/Api";
import { getFromLocalStorage } from "../../../../../utils/common-utils";
import "./editPackage.css";

const EditFallback = ({ editData, onUpdate }) => {
  const [fallbackData, setFallbackData] = useState({
    status: false,
    fallbackList: []
  });

  useEffect(() => {
    if (editData?.appStoreProductFallbackModelList) {
      setFallbackData({
        status: editData.appStoreProductFallbackModelList.length > 0,
        fallbackList: editData.appStoreProductFallbackModelList.map(item => ({
          id: item.id,
          pricePoint: item.pricePoint || "",
          validity: item.validity || ""
        }))
      });
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === 'radio') {
      const isYes = value === 'Yes';
      setFallbackData(prev => ({
        ...prev,
        status: isYes,
        fallbackList: isYes ? [{ pricePoint: "", validity: "" }] : []
      }));
    }
  };

  const handleFallbackChange = (index, field, value) => {
    setFallbackData(prev => ({
      ...prev,
      fallbackList: prev.fallbackList.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  const addFallback = () => {
    setFallbackData(prev => ({
      ...prev,
      fallbackList: [...prev.fallbackList, { pricePoint: "", validity: "" }]
    }));
  };

  const removeFallback = (index) => {
    setFallbackData(prev => ({
      ...prev,
      fallbackList: prev.fallbackList.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (fallbackData.status) {
      const invalidEntries = fallbackData.fallbackList.some(
        item => !item.pricePoint || !item.validity
      );
      if (invalidEntries) {
        Swal.fire({
          icon: "error",
          text: "Please fill in both Price and Validity for all entries",
        });
        return;
      }
    }

    try {
      // New payload structure
      const payload = {
        userId: getFromLocalStorage("userData")?.id,
        productId: editData?.id,
        isFallback: fallbackData.status,
        productFallbackList: fallbackData.status
          ? fallbackData.fallbackList.map(item => ({
            pricePoint: parseFloat(item.pricePoint),
            validity: parseInt(item.validity)
          }))
          : []
      };

      const response = await updateFallbackDetails(payload);

      if (response?.statusDescription?.status === 200) {
        onUpdate(response.productModel);
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description || "Fallback details updated successfully!",
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response?.statusDescription?.description || "Failed to update fallback details",
        });
      }
    } catch (error) {
      console.error("Error updating fallback details:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to update fallback details",
      });
    }
  };

  return (
    <div className="tab-content-section">
      {/* <div className="tab-content"> */}
      <div className="tab-pane active">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12 mb-3">
              <div className="form-group">

                <label className="d-block">
                  Fallback<span className="text-danger">*</span>
                </label>
                <div className="d-flex align-items-center">
                  {/* <div className="form-check mr-3"> */}
                  <input
                    type="radio"
                    className="form-check-input"
                    name="status"
                    value="Yes"
                    checked={fallbackData.status === true}
                    onChange={handleChange}
                    id="fallbackYes"
                  />
                  {/* <label className="form-check-label" htmlFor="fallbackYes">Yes</label> */}
                  <span className="ml-1">Yes</span>

                  {/* </div> */}
                  {/* <div className="form-check"> */}
                  <input
                    type="radio"
                    // className="form-check-input"
                    name="status"
                    value="No"
                    checked={fallbackData.status === false}
                    onChange={handleChange}
                    id="fallbackNo"
                    className="ml-3"

                  />
                  {/* <label className="form-check-label" htmlFor="fallbackNo">No</label> */}
                  <span className="ml-1">No</span>

                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>

          {fallbackData.status && fallbackData.fallbackList.map((item, index) => (
            <div className="row align-items-end mb-3" key={index}>
              <div className="form-group col-md-4 mb-0 price">
                {/* <div className="form-group mb-0"> */}
                <label>Price<span className="text-danger">*</span></label>
                <input
                  type="number"
                  className="form-control"
                  value={item.pricePoint}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || (
                      !isNaN(value) &&
                      value >= 0 &&
                      value.toString().length <= 10
                    )) {
                      handleFallbackChange(index, 'pricePoint', value);
                    }
                  }}
                  onKeyPress={(e) => {
                    if (e.key === '-' || e.key === '+' || e.key === 'e') {
                      e.preventDefault();
                    }
                  }}
                  min="0"
                  step="0.01"
                  placeholder="Price in Local Currency"
                  onWheel={(e) => e.target.blur()}
                />
                {/* </div> */}
              </div>
              <div className="form-group col-md-4 mb-0 validity">
                {/* <div className="form-group mb-0"> */}
                <label>Validity (In Days)<span className="text-danger">*</span></label>
                <input
                  type="number"
                  className="form-control"
                  value={item.validity}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || (
                      Number.isInteger(Number(value)) &&
                      value >= 0 &&
                      value.toString().length <= 4
                    )) {
                      handleFallbackChange(index, 'validity', value);
                    }
                  }}
                  onKeyPress={(e) => {
                    if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                      e.preventDefault();
                    }
                  }}
                  min="0"
                  max="9999"
                  placeholder="Enter Validity"
                  onWheel={(e) => e.target.blur()}
                />
                {/* </div> */}
              </div>
              <div className="col-md-4  plus_minus ps-0">
                <div className="d-flex mt-md-0 mt-3">
                  {index === fallbackData.fallbackList.length - 1 && (
                    <button
                      type="button"
                      className="btn btn-primary mr-2 pt-0 px-2"
                      onClick={addFallback}
                    >
                      +
                    </button>
                  )}
                  {fallbackData.fallbackList.length > 1 && (
                    <button
                      type="button"
                      className="btn btn-danger pt-0 px-2"
                      onClick={() => removeFallback(index)}
                    >
                      -
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}

          <div className="row mt-4">
            <div className="col-md-12 buttons_divs">
              <button
                type="submit"
                className="btn btn-primary float-right"
              >
                Update Fallback Details
              </button>
            </div>
          </div>
        </form>
      </div>
      {/* </div> */}
    </div>
  );
};

export default EditFallback;


